import { useSelector, useDispatch } from "react-redux";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import {
  hideTermConditionModal,
  updateLatestVersion,
} from "@/app/redux/latest-version-modal-management/latest-version-modal-management-clice";
import { getCookieValue, onUnAuthorizeLogoutHandle } from "@/app/utils/utility";
import { useState } from "react";

export default function TermConditionConfirmationModal() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const isOpen = useSelector(state => state.modal.isTermConditionModalOpen);

  const onAcceptSubmitHandle = async () => {
    setLoading(true);
    let response = await updateLatestVersion(getCookieValue("userID"));
    if (response?.status) {
      dispatch(hideTermConditionModal());
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={isOpen}
      onOpenChange={() => {
        dispatch(hideTermConditionModal());
      }}
      className="text-center"
    >
      <DialogContent>
        <DialogHeader className="flex justify-center items-center">
          <DialogTitle className="text-2xl font-semibold mt-4 text-center mb-4">
            Please Accept Latest
            <br /> Privacy & Policy, Terms & Conditions.
          </DialogTitle>
          <div className="flex">
            <Button
              onClick={() => {
                if (window.location.href.includes("/sign-in")) {
                  dispatch(hideTermConditionModal());
                } else {
                  onUnAuthorizeLogoutHandle();
                }
              }}
              size="lg"
              className="mr-4 w-[150px]"
            >
              Cancel
            </Button>
            <Button
              className="ml-4 w-[150px]"
              onClick={() => {
                if (!loading) {
                  onAcceptSubmitHandle();
                }
              }}
              size="lg"
              loading={loading}
            >
              Accept
            </Button>
          </div>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
